import React, { useState } from "react";
import "../../vip/vip.css"; // ensure inline convert button styles load
import BackBtn from "../../common/backBTN";
import { Link } from "react-router-dom";
import VipConversionForm from "../../vip/components/VipConversionForm";
import { useVipModule } from "../../vip/hooks/useVipModule";

function RewadCenter({userData, refreshPrivateData}) {
  const remoteId = userData?.remote_id;
  const vip = useVipModule({ pollMs: 60000, minRequired: 10, remoteId, onExternalRefresh: refreshPrivateData });
  const [showVipConvert, setShowVipConvert] = useState(false);
    return(
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="reward-center-container">
    <div className="reward-center">
      <div className="mc-header-wrap">
        <div id="mc-header" className="mc-navbar-blue mc-rewardCenter mc-default-header am-navbar am-navbar-light">
         <BackBtn/>
          <div className="am-navbar-title">Reward Center</div>
          <div className="am-navbar-right" />
        </div>
        <div className="am-whitespace am-whitespace-sm mc-whitespace" />
      </div>
      <div className="common-center-top false false" style={{background: '#1a2e2a', borderRadius:'.28rem'}}>
        <div>
          <div className="cumulative-sign-in"><a href="/m/activity/signIn">Sign In</a></div>
        </div>
        <div className="common-member-info">
          <div className="common-top-img">
            <div className="profile-icon">
              <img src="https://images.384894992.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png" alt="" />
            
            </div>
          </div>
          <div className="user-info">
            <div className="user-name">
              <div className="copy-account">
                <span>{userData?.name}</span><svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md"><use xlinkHref="#icon-copy_17d4102f" /></svg>
              </div>
            </div>
            <div className="nickname-edit">
              <div className="nickname-info">
                <span className="info-title">
                 Nickname
                </span>
                <span className="name-text">{userData?.username}</span>
              </div>
              <a className="go-to-edit" href="/m/myAccount/nickName">
                <svg className="am-icon am-icon-icon-edit_68c0ffef am-icon-md"><use xlinkHref="#icon-edit_68c0ffef" /></svg>
              </a>
            </div>
            <div className="false amount-info">
              <div className="amount-balance-common">
                <span className="currency">৳</span>
                {/* react-text: 3791 */}&nbsp;{/* /react-text */}
                <span className="number-mc undefined">{userData?.balance}</span>
              </div>
              <svg className="am-icon am-icon-refresh_e506c375 am-icon-md false refresh-balance"><use xlinkHref="#refresh_e506c375" /></svg>
            </div>
          </div>
        </div>
        <div className="common-member-level">
          <div className="level-top" style={{display:'flex', alignItems:'center', justifyContent:'flex-start', gap:'12px', padding:'4px 0'}}>
            <div className="member-level-name false" style={{display:'flex', alignItems:'center', gap:'12px', fontWeight:'600'}}>
              <span style={{fontSize:'14px'}}>VIP {vip.vipBalance ?? userData?.vip_coin ?? 0}</span>
              {!showVipConvert && (
                <button
                  type="button"
                  className="vip-inline-button"
                  onClick={() => setShowVipConvert(true)}
                >Convert</button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="task-list-warp">

        <Link to={"/rebateBonus"} className="false task-list-item">
          <img src="/icons/reward/card-bonus-bg.svg" alt="receiving_center" className="item-bg" />
          <div className="receiving_center item-icon">
            <img src="/icons/reward/icon-bonus.svg" alt="receiving_center" />
          </div>
          <div className="task-list-title">
            <div>
              Bonus
            </div>
          </div>
        </Link>
       
        <Link to={"/mission"} className="true task-list-item">
          <img src="/icons/reward/card-task-bg.svg" alt="novice_task" className="item-bg" />
          <div className="novice_task item-icon">
            <img src="/icons/reward/icon-task.svg" alt="novice_task" />
          </div>
          <div className="task-list-title">
            <div>
              Task
            </div>
          </div>
        </Link>
      
        <Link to={'/referral'} className="false task-list-item">
          <img src="/icons/reward/card-invite-bg.svg" alt="invite_friends" className="item-bg" />
          <div className="invite_friends item-icon"><img src="/icons/reward/icon-invite.svg" alt="invite_friends" /></div>
          <div className="task-list-title">
            <div>
              Invite Friends
            </div>
          </div>
        </Link>
        <Link to={'/promotion'} className="false task-list-item">
          <img src="/icons/reward/card-promo-bg.svg" alt="label_promo_code" className="item-bg" />
          <div className="label_promo_code item-icon"><img src="/icons/reward/icon-promo.svg" alt="label_promo_code" /></div>
          <div className="task-list-title">
            <div>
              Promo Code
            </div>
          </div>
        </Link>

      </div>
      {/* VIP Conversion Module (modal toggle) */}
      {showVipConvert && (
        <VipConversionForm
          vm={vip}
          modal
          theme="light"
          onClose={() => setShowVipConvert(false)}
        />
      )}
    </div>
  </div>
</div>

    );
}
export default RewadCenter;